var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonMonoxideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1434 3.25265e-05C3.79682 3.25265e-05 2.45821 0.571959 1.50613 1.55474C0.554057 2.53752 0 3.9193 0 5.30931C0 6.69933 0.554057 8.08111 1.50613 9.06389C2.45821 10.0467 3.79682 10.6186 5.1434 10.6186C5.89639 10.6163 6.64778 10.4406 7.32846 10.1083V10.1085C7.5488 10.0008 7.81158 10.0578 7.97134 10.2479L8.75239 11.1748C8.90952 11.3614 8.92963 11.6324 8.80189 11.8416C8.41447 12.4767 8.2041 13.2252 8.20229 13.9758V13.9764V13.9771C8.20251 15.0302 8.62264 16.0768 9.34401 16.8215C10.0656 17.5663 11.0802 18 12.1008 18C13.1217 18 14.1358 17.5665 14.8577 16.8215C15.5795 16.0764 16 15.0295 16 13.9757C16 12.922 15.5801 11.8744 14.8583 11.1294C14.1367 10.3845 13.1225 9.95105 12.1021 9.95082H12.1008C11.541 9.95241 10.9819 10.0809 10.474 10.3238H10.4738C10.2543 10.4287 9.99398 10.3713 9.83531 10.1826L9.14977 9.36818H9.14954C8.97672 9.16264 8.97164 8.85854 9.13783 8.64704C9.87265 7.71215 10.2855 6.51288 10.287 5.30881C10.2868 3.91903 9.73274 2.53749 8.78066 1.55494C7.82858 0.571926 6.48999 3.25265e-05 5.1434 3.25265e-05Z",
    fill: "#20E89C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonMonoxideIcon);
export default __webpack_public_path__ + "static/media/CarbonMonoxideIcon.5c9a43e5011a59d226fb9aff2100c487.svg";
export { ForwardRef as ReactComponent };